/* eslint-disable max-len */
export const ROUTE_ACCOUNT_ACCOUNT_PASSWORD = '/account/account-password';
export const ROUTE_ACCOUNT_APPOINTMENTS = '/account/appointments';
export const ROUTE_ACCOUNT_APPOINTMENTS_DETAIL = '/account/appointments/:id';
export const ROUTE_ACCOUNT_CARS = '/account/cars';
// Your vehicles: photos and inspection reports (MyVehicles, MyVehicleDetail).
export const ROUTE_ACCOUNT_GARAGE = '/account/vehicles';
export const ROUTE_ACCOUNT_GARAGE_DETAIL = '/account/vehicles/:id';
export const ROUTE_ACCOUNT_CUSTOMER_INFORMATION = '/account/customer-information';
export const ROUTE_ACCOUNT_ROOT = '/account';
export const ROUTE_AUTH_FORGOT_PASSWORD = '/auth/forgot-password';
export const ROUTE_AUTH_SIGN_UP = '/auth/sign-up';
export const ROUTE_AUTH_LOGIN = '/auth/login';
export const ROUTE_AUTH_LOGOUT = '/auth/logout';
export const ROUTE_BOOK_ADD_ONS = '/book/select-add-ons';
export const ROUTE_BOOK_CONFIRMATION = '/book/confirmation';
export const ROUTE_BOOK_LOCATION = '/book/location';
export const ROUTE_BOOK_PAYMENT = '/book/pay';
export const ROUTE_BOOK_ROOT = '/book';
export const ROUTE_BOOK_SCHEDULE = '/book/schedule-book';
export const ROUTE_BOOK_SERVICES = '/book/select-services';
export const ROUTE_ROOT = '/';
/** The QR code on an Aperio member card (Google Wallet): the service record. */
export const ROUTE_SERVICE_RECORD = '/r/:token';
export const ROUTE_DOCUMENT_LINK = '/d/:code';
// An outside shop's shared-inspection link: `/i#<token>` (the token stays in
// the fragment, never in a server log or analytics).
export const ROUTE_SHOP_INSPECTION = '/i';
export const ROUTE_FRANCHISE_MANAGER = '/account/franchisee';
export const ROUTE_FRANCHISE_MANAGER_WORK_ORDERS = '/account/franchisee/work-orders';
export const ROUTE_FRANCHISE_MANAGER_CUSTOMERS = '/account/franchisee/customers';
export const ROUTE_FRANCHISE_MANAGER_CREATE_CUSTOMER = '/account/franchisee/customers/create-customer';
// export const ROUTE_FRANCHISE_MANAGER_FRANCHISES = '/account/franchisee/franchises';
export const ROUTE_FRANCHISE_MANAGER_WORK_ORDER_DETAIL = '/account/franchisee/work-orders/:id';
export const ROUTE_FRANCHISE_MANAGER_CUSTOMER_DETAIL = '/account/franchisee/customers/:id';
export const ROUTE_FRANCHISE_MANAGER_INVOICES = '/account/franchisee/invoices';
export const ROUTE_FRANCHISE_MANAGER_INVOICE_DETAIL = '/account/franchisee/invoices/:invoiceNumber';
export const ROUTE_FRANCHISE_MANAGER_PAYOUTS = '/account/franchisee/payout';
export const ROUTE_FRANCHISE_TECHNICIAN_PAYOUTS = '/account/franchisee/technician-payouts';
export const ROUTE_FRANCHISE_SALES_PAYOUTS = '/account/franchisee/sales-payouts';
export const ROUTE_FRANCHISE_MANAGER_PAYOUT_DETAIL = '/account/franchisee/payout/:id';
export const ROUTE_FRANCHISE_MANAGER_ANALYTICS = '/account/franchisee/analytics';
export const ROUTE_FRANCHISE_SALES_ANALYTICS = '/account/franchisee/sales-analytics';
export const ROUTE_FRANCHISE_INVENTORY = '/account/franchisee/inventory';
export const ROUTE_FRANCHISE_MANAGER_VANS_PAYOUTS = '/account/franchisee/van-payout';

export const ROUTE_FLEET_MANAGER = '/fleet';
export const ROUTE_FLEET_SIGN_UP = '/fleet/signup';
export const ROUTE_FLEET_DASHBOARD = '/fleet/dashboard';
export const ROUTE_FLEET_VEHICLES = '/fleet/vehicles';
export const ROUTE_FLEET_VEHICLE_DETAIL = '/fleet/vehicles/:id';
export const ROUTE_FLEET_SERVICE = '/fleet/service';
export const ROUTE_FLEET_REPAIRS = '/fleet/repairs';
export const ROUTE_FLEET_REPAIR_DETAIL = '/fleet/repairs/:id';
export const ROUTE_FLEET_ALERTS = '/fleet/alerts';
export const ROUTE_FLEET_STAFF = '/fleet/staff';
export const ROUTE_FLEET_SETTINGS = '/fleet/settings';
export const ROUTE_FLEET_DRIVERS = '/fleet/drivers';
// A fleet driver's phone screen: sign vehicles out and in.
export const ROUTE_DRIVER = '/driver';
export const ROUTE_SHOP_PORTAL = '/shop';
